import { render, staticRenderFns } from "./ProdutoAssociarTags.vue?vue&type=template&id=43b7f263&"
import script from "./ProdutoAssociarTags.vue?vue&type=script&lang=js&"
export * from "./ProdutoAssociarTags.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoAssociarTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports